import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Hebsan")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("FR")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("DE")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("DE")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("FR")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("FR")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("DE")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("DE")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("FR")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      size: "small",
                      color: "light",
                      disabled: "",
                      fill: "solid"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    (_ctx.language.abbrev == 'fr')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_6,
                          _createVNode(_component_ion_button, {
                            size: "small",
                            color: "light"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }),
                          _hoisted_8,
                          _createVNode(_component_ion_button, {
                            size: "small",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('de')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          })
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_10,
                          _createVNode(_component_ion_button, {
                            size: "small",
                            color: "light"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }),
                          _hoisted_12,
                          _createVNode(_component_ion_button, {
                            size: "small",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('fr')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          })
                        ], 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_14,
            _createVNode(_component_router_link, { to: "/ABCFeasts" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.useTranslate("calendar", _ctx.language.abbrev)) + "  ", 1),
                _createVNode(_component_ion_icon, { icon: _ctx.chevronForward }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _hoisted_15,
            _hoisted_16,
            _hoisted_17,
            _createVNode(_component_ion_note, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.useTranslate("calendarExpla", _ctx.language.abbrev)), 1)
              ]),
              _: 1
            }),
            _hoisted_18,
            _hoisted_19,
            _hoisted_20,
            _createVNode(_component_router_link, { to: "/HebdomadaSancta" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.useTranslate("sancta", _ctx.language.abbrev)) + "  ", 1),
                _createVNode(_component_ion_icon, { icon: _ctx.chevronForward }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _hoisted_21,
            _hoisted_22,
            _hoisted_23,
            _createVNode(_component_ion_note, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.useTranslate("sanctaExpla", _ctx.language.abbrev)), 1)
              ]),
              _: 1
            }),
            _hoisted_24,
            _hoisted_25,
            _hoisted_26,
            _hoisted_27,
            _createVNode(_component_router_link, { to: "/AboutPage" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.useTranslate("about", _ctx.language.abbrev)) + "  ", 1),
                _createVNode(_component_ion_icon, { icon: _ctx.chevronForward }, null, 8, ["icon"])
              ]),
              _: 1
            }),
            _hoisted_28,
            _hoisted_29,
            _hoisted_30,
            _createVNode(_component_ion_note, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.useTranslate("aboutExpla", _ctx.language.abbrev)), 1)
              ]),
              _: 1
            }),
            _hoisted_31,
            _hoisted_32,
            _hoisted_33
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          (_ctx.language.abbrev == 'fr')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_34,
                _createVNode(_component_ion_button, {
                  size: "small",
                  color: "light"
                }, {
                  default: _withCtx(() => [
                    _hoisted_35
                  ]),
                  _: 1
                }),
                _hoisted_36,
                _createVNode(_component_ion_button, {
                  size: "small",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLang('de')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_37
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_38,
                _createVNode(_component_ion_button, {
                  size: "small",
                  color: "light"
                }, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 1
                }),
                _hoisted_40,
                _createVNode(_component_ion_button, {
                  size: "small",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLang('fr')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_41
                  ]),
                  _: 1
                })
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}